var transformSize = function (size) {
    if (size === void 0) { size = 48; }
    switch (size) {
        case 'xxs':
            return 24;
        case 'xs':
            return 32;
        case 's':
            return 40;
        default:
            return size;
    }
};

export { transformSize };
